import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import { IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5';

class EditModal extends Component {
    state = {
        name: "",
        email: "",
        phone: "",
        password: "",
        profile_photo: "",
        passType: "password",
        directory: "",
        editError: {
            state: false,
            message: ""
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.user !== prevProps.user && this.props.user !== null) {
            this.setState({
                name: this.props.user.name,
                email: this.props.user.email,
                phone: this.props.user.phone,
                password: this.props.user.password,
                profile_photo: this.props.user.profile_photo,
            })
        }
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value,
            editError: {
                state: false,
                message: ""
            }
        })
    }

    togglePass = () => {
        if (this.state.passType === "password") {
            this.setState({
                passType: "text"
            })
        } else {
            this.setState({
                passType: "password"
            })
        }   
    }

    handleCloseModal = () => {
        this.setState({
            name: "",
            email: "",
            phone: "",
            password: "",
            profile_photo: "",
            passType: "password",
            directory: "",
            editError: {
                state: false,
                message: ""
            }
        })
        this.props.closeEditModal()
    }

    onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            this.setState({directory: event.target.value})
            let reader = new FileReader();
            reader.onload = (e) => {
                this.setState({profile_photo: e.target.result})
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    updateUser = e => {
        e.preventDefault();
        this.setState({
            editError: {
                state: false,
                message: ""
            }
        })
        const { name, email, phone, password, profile_photo } = this.state;
        const data = { name, email, phone, password, profile_photo }
        this.props.updateUser(this.props.user._id, data)
        .then(result => {
            console.log(result);
            if (result.error && result.error !== null) {
                this.setState({
                    editError: {
                        state: true,
                        message: result.error.message
                    }
                })
            } else {
                this.handleCloseModal()
            }
        })
    }

    render() {
        // console.log(this.state)
        const { profile_photo, name, email, phone, password, editError, directory, passType } = this.state;
        return (
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.props.show}
                className="t-modal edit-modal"
                onHide={this.handleCloseModal}
            >
                <Modal.Header>
                    <button className="close-btn" onClick={this.handleCloseModal}>×</button>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <img className="ms-3 mb-1" src="/icons/edit.png" alt="edit" width="30" />
                        تعديل بيانات المشرف
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={this.updateUser}>
                        <div className="add-form__logo-input w-100 my-2">
                            <input type="file" name="profile_photo" className="d-none" id="superEditLogo" onChange={this.onImageChange} accept="image/*" />
                            <label className="w-100 d-flex justify-content-between" htmlFor="superEditLogo">
                                <img className="mx-1" src={this.props.user === null || profile_photo === null || profile_photo === "" ? "/images/user-profile-placeholder-image.png" : profile_photo} alt="profile" width="60" />
                                <span className="align-self-center">{directory}</span>
                                <img className="mx-3 align-self-center" src="/icons/photo-camera-interface-symbol-for-button-blue.png" alt="camera" height="40" width="auto" />
                            </label>
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="text" name="name" className="w-100 m-0 px-3 py-2" value={name} onChange={this.handleChange} />
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="email" name="email" className="w-100 m-0 px-3 py-2" value={email} onChange={this.handleChange} />
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="text" name="phone" className="w-100 m-0 px-3 py-2 text-end" value={phone} onChange={this.handleChange} style={{direction: "ltr"}} />
                        </div>
                        <div className="add-form__text-input w-100 my-2 position-relative">
                            <input type={passType} name="password" className="w-100 m-0 px-3 py-2" value={password} onChange={this.handleChange} />
                            {passType === "password"
                                ? <IoEyeOutline size="1.6rem" style={{position: "absolute", left: "10px", top: "25%", cursor: "pointer"}} onClick={this.togglePass} />
                                : <IoEyeOffOutline size="1.6rem" style={{position: "absolute", left: "10px", top: "25%", cursor: "pointer"}} onClick={this.togglePass} />
                            }
                        </div>
                        <div className="alert alert-danger text-center mb-5 fs-5" role="alert" style={{display: editError.state ? "block" : "none"}}>
                            {editError.message}
                        </div>
                        <button type="submit" className="px-4 py-2 mx-2 my-4 blue-btn">حفظ</button>
                    </form>
                </Modal.Body>
            </Modal>
        );
    }
}

export default EditModal;